import { render } from "./BaseSpinner.vue?vue&type=template&id=e8b75b42&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=e8b75b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8b75b42"]])

export default __exports__